import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import ImageUploadModal from 'components/common/ImageUploadModal';
import { BACKGROUND_TYPE } from 'features/Genre/constans';
import { Genre } from 'features/Genre/models/Genre';
import { Formik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { Alert, Button, Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IMAGE_SIZES } from 'utils/constants';
import * as yup from 'yup';
import ModalPreView from '../../../components/ModalPreView';
import service from '../services';
interface PropsData {
  genre: Genre;
  id: string;
  handleCloseModalEdit: (status: boolean, data: Genre) => void;
  dataTable?: Genre[];
  setDataTable?: (genres: Genre[]) => void;
}

function GenreFormDetail({ genre, id, handleCloseModalEdit, dataTable, setDataTable }: PropsData) {
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const [showModalPreView, setShowModalPreView] = useState(false);
  const [previewImage, setPreviewImg] = useState<string>('');
  const [previewBg, setPreviewBg] = useState<string>('');
  const schema = yup.object().shape({
    name: yup.string().required(t('Genre.Validator.name')),
  });

  useEffect(() => {
    if (genre && typeof genre.img == 'string' && genre.img) {
      setPreviewImg(genre.img);
    }
    if (genre && typeof genre.background_img == 'string' && genre.background_img) {
      setPreviewBg(genre.background_img);
    }
  }, [genre]);

  const [genrePreview, setGenrePreview] = useState<Genre>({
    id: genre.id,
    name: genre.name,
    img: genre.img,
    background_color: genre.background_color,
    background_img: genre.background_img,
    display_name: genre.display_name,
    display_name_ja: genre.display_name_ja,
    display_name_en: genre.display_name_en,
    display_name_vi: genre.display_name_vi,
    display_name_ko: genre.display_name_ko,
    display_name_zh_hant: genre.display_name_zh_hant,
    display_name_zh_hans: genre.display_name_zh_hans,
    note: genre.note,
    delete_flg: genre.delete_flg,
    background_type: genre.background_type,
  });

  const initialValues: Genre = {
    id: genre?.id ? genre.id : 0,
    name: genre?.name ? genre.name : '',
    img: genre?.img,
    background_color: genre?.background_color ? genre.background_color : '',
    background_img: genre?.background_img,
    display_name: genre?.display_name ? genre.display_name : '',
    display_name_ja: genre?.display_name_ja ? genre.display_name_ja : '',
    display_name_en: genre?.display_name_en ? genre.display_name_en : '',
    display_name_vi: genre?.display_name_vi ? genre.display_name_vi : '',
    display_name_ko: genre?.display_name_ko ? genre.display_name_ko : '',
    display_name_zh_hant: genre?.display_name_zh_hant ? genre.display_name_zh_hant : '',
    display_name_zh_hans: genre?.display_name_zh_hans ? genre.display_name_zh_hans : '',
    note: genre?.note ? genre.note : '',
    delete_flg: false,
    background_type: genre.background_type,
  };

  function onClose(status: boolean, data: Genre) {
    handleCloseModalEdit && handleCloseModalEdit(true, data);
  }

  async function HandleSubmitForm(values: Genre) {
    await service
      .updateGenre(values, id)
      .then((res) => {
        const tables = dataTable?.map((value: Genre) => {
          if (value.id === res.data.id) {
            value = res.data;
            return value;
          }
          return value;
        });
        if (tables) setDataTable && setDataTable(tables);

        return res.data;
      })
      .then((data) => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={onClose.bind(null, true, data)}
              title={t('Genre.Validator.success')}
              message={t('Genre.Validator.add_success')}
            ></AlertModal>
          ));
      })
      .catch((error) => {
        showGlobalModal(() => (
          <AlertModal
            title={t('Genre.Validator.error')}
            message={JSON.stringify(error.response.data.data)}
          ></AlertModal>
        ));
      });
  }

  function handleShowModalPreview() {
    setShowModalPreView(true);
  }

  function handleCloseModalPreview() {
    setShowModalPreView(false);
  }

  const refRadioBtnBackgrounImg = useRef<HTMLInputElement>(null);
  const refRadioBtnBackgrounColor = useRef<HTMLInputElement>(null);

  return (
    <Formik validationSchema={schema} onSubmit={HandleSubmitForm} initialValues={initialValues}>
      {({ handleSubmit, handleChange, values, errors, setFieldValue }) => {
        return (
          <Form noValidate onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Col sm={2} md={2} lg={2} xl={2} style={{ display: 'none' }}>
                <Button onClick={handleShowModalPreview} className="btn--orange">
                  {t('Genre.Button.preview')}
                </Button>
                <ModalPreView
                  show={showModalPreView}
                  handleCloseModalPreview={handleCloseModalPreview}
                  genre={genrePreview}
                ></ModalPreView>
              </Col>
              <Col sm={8} md={8} lg={8} xl={8} style={{ display: 'none' }}>
                <div dangerouslySetInnerHTML={{ __html: t('Genre.Headers.Desc') }}></div>
              </Col>
              <Col style={{ textAlign: 'right' }}>
                <Button
                  className="pull-right"
                  onClick={() => {
                    handleSubmit();
                  }}
                  variant="success"
                >
                  {t('Genre.Button.keep')}
                </Button>
              </Col>
            </Form.Group>
            <Table bordered className="table-genre">
              <tbody>
                <tr>
                  <th colSpan={3} style={{ backgroundColor: '#36489a', width: '50%' }}>
                    {t('Genre.Form.genre_name')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                      placeholder={t('Genre.Form.genre_name')}
                      isInvalid={!!errors.name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('Genre.Form.image')}
                  </th>
                  <td className="genre">
                    <input
                      type="button"
                      onClick={() => {
                        showGlobalModal &&
                          showGlobalModal(() => (
                            <ImageUploadModal
                              imagepath={
                                previewImage && previewImage.length > 0
                                  ? process.env.REACT_APP_IMAGE_URL + previewImage
                                  : ''
                              }
                              minWidth={IMAGE_SIZES.genre_order_background_img.minWidth}
                              minHeight={IMAGE_SIZES.genre_order_background_img.minHeight}
                              maxWidth={IMAGE_SIZES.genre_order_background_img.maxWidth}
                              maxHeight={IMAGE_SIZES.genre_order_background_img.maxHeight}
                              maxFileSize={IMAGE_SIZES.genre_order_background_img.maxFileSize}
                              onReflect={(filename: string, imagepath: string) => {
                                setFieldValue('img', filename);
                                setPreviewImg(filename);
                              }}
                            />
                          ));
                      }}
                      id="actual-img"
                      hidden
                      name="img"
                    />
                    <label htmlFor="actual-img" style={{ marginRight: 10 }}>
                      {t('Genre.Form.image')}
                    </label>
                    {previewImage && (
                      <img src={process.env.REACT_APP_IMAGE_URL + previewImage} alt="img" width={45} height={45} />
                    )}
                  </td>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a', width: '13%' }} rowSpan={3}>
                    {t('Genre.Form.background')}
                  </th>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a', width: '13%' }} colSpan={2}>
                    {t('Genre.Form.color')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          defaultChecked={values.background_type === BACKGROUND_TYPE.COLOR ? true : false}
                          name="background_type"
                          value={0}
                          onChange={(event) => {
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_type: BACKGROUND_TYPE.COLOR,
                            });
                          }}
                          ref={refRadioBtnBackgrounColor}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        <Alert
                          key="danger"
                          variant="light"
                          style={{
                            textAlign: 'center',
                            backgroundColor: values.background_color,
                            height: 45,
                            color: '#ffffff',
                          }}
                        >
                          {values.name}
                        </Alert>
                      </Col>
                      <Col>
                        <Form.Control
                          id="actual-color"
                          type="color"
                          value={values.background_color}
                          name="background_color"
                          onChange={(event) => {
                            if (refRadioBtnBackgrounColor.current) {
                              refRadioBtnBackgrounColor.current.click();
                            }
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_color: event.target.value,
                            });
                          }}
                          style={{ width: 45, height: 45 }}
                        />
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr style={{ display: 'none' }}>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.image')}
                  </th>
                  <td>
                    <Form.Group as={Row} className="mb-3">
                      <Col sm={2} md={2} lg={2} xl={2}>
                        <Form.Check
                          type="radio"
                          name="background_type"
                          defaultChecked={values.background_type === BACKGROUND_TYPE.IMG ? true : false}
                          onChange={(event) => {
                            handleChange(event);
                            setGenrePreview({
                              ...genrePreview,
                              background_type: BACKGROUND_TYPE.IMG,
                            });
                          }}
                          value={1}
                          ref={refRadioBtnBackgrounImg}
                        />
                      </Col>
                      <Col sm={8} md={8} lg={8} xl={8}>
                        {previewBg && (
                          <img
                            src={process.env.REACT_APP_IMAGE_URL + previewBg}
                            alt="img"
                            width={IMAGE_SIZES.genre_order_background_img.minWidth}
                            height="auto"
                          />
                        )}
                      </Col>
                      <Col className="genre">
                        <input
                          type="button"
                          id="actual-btn"
                          hidden
                          name="background_img"
                          onClick={() => {
                            if (refRadioBtnBackgrounImg.current) {
                              refRadioBtnBackgrounImg.current.click();
                            }
                            showGlobalModal &&
                              showGlobalModal(() => (
                                <ImageUploadModal
                                  imagepath={
                                    previewBg && previewBg.length > 0 ? process.env.REACT_APP_IMAGE_URL + previewBg : ''
                                  }
                                  minWidth={IMAGE_SIZES.genre_order_background_img.minWidth}
                                  minHeight={IMAGE_SIZES.genre_order_background_img.minHeight}
                                  maxWidth={IMAGE_SIZES.genre_order_background_img.maxWidth}
                                  maxHeight={IMAGE_SIZES.genre_order_background_img.maxHeight}
                                  maxFileSize={IMAGE_SIZES.genre_order_background_img.maxFileSize}
                                  onReflect={(filename: string) => {
                                    setFieldValue('background_img', filename);
                                    setPreviewBg(filename);
                                    setGenrePreview({
                                      ...genrePreview,
                                      background_img: filename,
                                    });
                                  }}
                                ></ImageUploadModal>
                              ));
                          }}
                        />

                        <label htmlFor="actual-btn" style={{ marginRight: 10 }}>
                          {t('Genre.Form.image')}
                        </label>
                      </Col>
                    </Form.Group>
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} rowSpan={7}>
                    {t('Genre.Form.display_name')}
                  </th>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.japanese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_ja: event.target.value,
                        });
                      }}
                      value={values.display_name_ja}
                      name="display_name_ja"
                      placeholder="セレクトランチ"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.english')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_en: event.target.value,
                        });
                      }}
                      value={values.display_name_en}
                      name="display_name_en"
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.simplified_chinese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hans"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_zh_hans: event.target.value,
                        });
                      }}
                      value={values.display_name_zh_hans}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.chinese_traditional')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      name="display_name_zh_hant"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_zh_hant: event.target.value,
                        });
                      }}
                      value={values.display_name_zh_hant}
                      placeholder="自由组合午餐"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.korean')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_ko: event.target.value,
                        });
                      }}
                      name="display_name_ko"
                      value={values.display_name_ko}
                      placeholder="셀렉트 점심"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={2}>
                    {t('Genre.Form.vietnamese')}
                  </th>
                  <td>
                    <Form.Control
                      type="text"
                      onChange={(event) => {
                        handleChange(event);
                        setGenrePreview({
                          ...genrePreview,
                          display_name_vi: event.target.value,
                        });
                      }}
                      name="display_name_vi"
                      value={values.display_name_vi}
                      placeholder="Select lunch"
                    />
                  </td>
                </tr>
                <tr>
                  <th style={{ backgroundColor: '#36489a' }} colSpan={3}>
                    {t('Genre.Form.remarks')}
                  </th>
                  <td>
                    <Form.Control as="textarea" onChange={handleChange} value={values.note} name="note" rows={3} />
                  </td>
                </tr>
              </tbody>
            </Table>
          </Form>
        );
      }}
    </Formik>
  );
}

export default GenreFormDetail;
